module.exports = __webpack_public_path__ + "img/car_00017.657378a0.jpg";